// import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Col, Row } from "reactstrap";
import './style-modal.scss';

function MineError(props) {
    return (
        <>{(props.message) ?
            <Row className={props.className||''}>
                <Col>
                    <Form.Text muted>
                        <div className={`error`} style={{ display: 'inline-flex' }}>
                            <div className="text-left" style={{ paddingRight: '0.625rem' }} >
                                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                            </div>
                            <div className="text-left">
                                {props.message}
                            </div>
                        </div>
                    </Form.Text>
                </Col>
            </Row>:null
        }
        </>
    );
}

export default MineError;